import {JsonProperty} from 'json-typescript-mapper';


export class BaseDataView {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('salutation')
  public salutation?: string;

  @JsonProperty('merchantId')
  public merchantId?: number;

  @JsonProperty('branch')
  public branch?: string;

  @JsonProperty('merchantChanges')
  public merchantChanges?: number;

  @JsonProperty('salesunitChanges')
  public salesunitChanges?: number;

  @JsonProperty('contactpersonChanges')
  public contactpersonChanges?: number;

  @JsonProperty('company')
  public company?: string;

  @JsonProperty('companyAdditional')
  public companyAdditional?: string;

  @JsonProperty('merchantNumber')
  public merchantNumber?: string;

  @JsonProperty('zipcode')
  public zipcode?: string;

  @JsonProperty('city')
  public city?: string;

  @JsonProperty('merchantUpdated')
  public merchantUpdated?: string;

  @JsonProperty('salesunitUpdated')
  public salesunitUpdated?: string;

  @JsonProperty('contactpersonUpdated')
  public contactpersonUpdated?: string;

  @JsonProperty('lastUpdate')
  public lastUpdate?: string;

  @JsonProperty('marketMasterFirstname')
  public marketMasterFirstname?: string;

  @JsonProperty('marketMasterLastname')
  public marketMasterLastname?: string;

  @JsonProperty('marketMasterNumber')
  public marketMasterNumber?: string;

  @JsonProperty('statusArchive')
  public statusArchive?: string;

  @JsonProperty('lastMarketdateId')
  public lastMarketdateId?: string;

  @JsonProperty('marketdayId')
  public marketdayId?: number;

  @JsonProperty('marketdayKeyword')
  public marketdayKeyword?: string;

  @JsonProperty('marketdayNumber')
  public marketdayNumber?: string;

  constructor() {
    this.id = void 0;
    this.salutation = void 0;
    this.merchantId = void 0;
    this.branch = void 0;
    this.merchantChanges = void 0;
    this.salesunitChanges = void 0;
    this.contactpersonChanges = void 0;
    this.company = void 0;
    this.companyAdditional = void 0;
    this.merchantNumber = void 0;
    this.zipcode = void 0;
    this.city = void 0;
    this.merchantUpdated = void 0;
    this.salesunitUpdated = void 0;
    this.contactpersonUpdated = void 0;
    this.lastUpdate = void 0;
    this.marketMasterFirstname = void 0;
    this.marketMasterLastname = void 0;
    this.marketMasterNumber = void 0;
    this.statusArchive = void 0;
    this.marketdayId = void 0;
    this.marketdayKeyword = void 0;
    this.marketdayNumber = void 0;
    this.lastMarketdateId = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/base-data-view.model.ts